import { render, staticRenderFns } from "./realName.vue?vue&type=template&id=1f9790b5&scoped=true"
import script from "./realName.vue?vue&type=script&lang=js"
export * from "./realName.vue?vue&type=script&lang=js"
import style0 from "./realName.vue?vue&type=style&index=0&id=1f9790b5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9790b5",
  null
  
)

export default component.exports